import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=2b3bffc9&"
import script from "./DriverList.vue?vue&type=script&lang=js&"
export * from "./DriverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports